import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';
import {
  BookAppointmentClinicContentData,
  BookAppointmentPatientContentData,
  BookAppointmentServiceTypeContentData,
  BookAppointmentAppointmentTypeContentData,
  BookAppointmentDoctorContentData,
  BookAppointmentDateTimeContentData,
  BookAppointmentAppointmentIdContentData,
  BookAppointmentPatientIdContentData,
} from '../lib/validation';

type State = {
  clinic: BookAppointmentClinicContentData | null;
  patient: BookAppointmentPatientContentData | null;
  serviceType: BookAppointmentServiceTypeContentData | null;
  appointmentType: BookAppointmentAppointmentTypeContentData | null;
  doctor: BookAppointmentDoctorContentData | null;
  datetime: BookAppointmentDateTimeContentData | null;
  patientId: BookAppointmentPatientIdContentData | null;
  appointmentId: BookAppointmentAppointmentIdContentData | null;
};

type Actions = {
  setData: (data: Partial<State>) => void;
  resetData: (data?: (keyof State)[]) => void;
};

const initialState: State = {
  clinic: null,
  patient: null,
  serviceType: null,
  appointmentType: null,
  doctor: null,
  datetime: null,
  patientId: null,
  appointmentId: null,
};

const useBookAppointmentStoreBase = createWithEqualityFn<State & Actions>()(set => ({
  ...initialState,
  setData: data =>
    set(state => ({
      ...state,
      ...data,
    })),
  resetData: data =>
    set(state => {
      if (!data) return initialState;

      data.forEach((name: string) => {
        if (Object.prototype.hasOwnProperty.call(initialState, name)) {
          state[name] = initialState[name];
        }
      });

      return state;
    }),
}));

export const useBookAppointmentStore = <U>(
  selector: (state: State & Actions) => U
) => {
  return useBookAppointmentStoreBase(selector, shallow);
};
